'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _createClass = require('@babel/runtime/helpers/createClass');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _typeof = require('@babel/runtime/helpers/typeof');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var isObject = function isObject(item) {
  return item && _typeof__default["default"](item) === 'object' && !Array.isArray(item);
};
var _deepMerge = function deepMerge(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  if (!sources.length) return target;
  var source = sources.shift();
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, _defineProperty__default["default"]({}, key, {}));
        }
        _deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, _defineProperty__default["default"]({}, key, source[key]));
      }
    });
  }
  return _deepMerge.apply(void 0, [target].concat(sources));
};
var Appearance = /*#__PURE__*/function () {
  function Appearance(appearance) {
    _classCallCheck__default["default"](this, Appearance);
    this.appearance = JSON.parse(JSON.stringify(appearance));
  }
  return _createClass__default["default"](Appearance, [{
    key: "document",
    get: function get() {
      return this.getComponentByName('Document');
    }
  }, {
    key: "layout",
    get: function get() {
      return this.getComponentByName('Layout');
    }
  }, {
    key: "fromTreeGetComponentByName",
    value: function fromTreeGetComponentByName(tree, name) {
      var _this = this;
      var result = null;
      if (tree) {
        if (tree.component === name || tree.component === "".concat(name, "Editable")) {
          return tree;
        }
        if (tree.children && tree.children.length > 0) {
          tree.children.find(function (child) {
            result = _this.fromTreeGetComponentByName(child, name);
            return result;
          });
        }
      }
      return result;
    }
  }, {
    key: "fromTreeGetComponentById",
    value: function fromTreeGetComponentById(tree, id) {
      var _this2 = this;
      var result = null;
      if (tree) {
        if (tree.id === id) {
          return tree;
        }
        if (tree.children && tree.children.length > 0) {
          tree.children.find(function (child) {
            result = _this2.fromTreeGetComponentById(child, id);
            return result;
          });
        }
      }
      return result;
    }
  }, {
    key: "fromTreeGetComponentByIdAndParent",
    value: function fromTreeGetComponentByIdAndParent(tree, id) {
      var _this3 = this;
      var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var result = null;
      if (tree) {
        if (tree.id === id) {
          return {
            parent: parent,
            component: tree
          };
        }
        if (tree.children && tree.children.length > 0) {
          tree.children.find(function (child) {
            result = _this3.fromTreeGetComponentByIdAndParent(child, id, tree);
            return result;
          });
        }
      }
      return result;
    }
  }, {
    key: "navigateToProperty",
    value: function navigateToProperty(props, prop) {
      var splitted = prop.split(/\.(.+)/, 2);
      if (!props) {
        return null;
      }
      if (splitted.length === 1) {
        return props[splitted[0]];
      }
      return this.navigateToProperty(props[splitted[0]], splitted[1]);
    }
  }, {
    key: "getComponentByName",
    value: function getComponentByName(name) {
      return this.fromTreeGetComponentByName(this.appearance, name);
    }
  }, {
    key: "getComponentById",
    value: function getComponentById(id) {
      return this.fromTreeGetComponentById(this.appearance, id);
    }
  }, {
    key: "getComponentProperty",
    value: function getComponentProperty(name, property) {
      var component = this.getComponentByName(name);
      if (component && component.properties) {
        return this.navigateToProperty(component.properties, property);
      }
      return null;
    }
  }, {
    key: "getTree",
    value: function getTree() {
      return this.appearance;
    }
  }, {
    key: "getChildrenFromTree",
    value: function getChildrenFromTree() {
      var _this4 = this;
      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var tree = arguments.length > 1 ? arguments[1] : undefined;
      if (tree.children && tree.children.length > 0) {
        node.children = {};
        tree.children.reduce(function (previous, current) {
          previous[current.id] = _this4.getChildrenFromTree(previous[current.id], current);
          return previous;
        }, node.children);
      }
      return node;
    }
  }, {
    key: "getCondensedTree",
    value: function getCondensedTree() {
      var condensedTree = {};
      this.getChildrenFromTree(condensedTree, this.getTree());
      return condensedTree;
    }
  }, {
    key: "reorderTreeChildren",
    value: function reorderTreeChildren(tree, from, to) {
      var childrenCopy = _toConsumableArray__default["default"](tree.children);
      childrenCopy.splice(to, 0, childrenCopy.splice(from, 1)[0]);
      tree.children = childrenCopy;
    }
  }, {
    key: "getLayoutComponentIndex",
    value: function getLayoutComponentIndex(componentId) {
      var component = this.fromTreeGetComponentById(this.layout, componentId);
      if (!component) {
        return -1;
      }
      var checkComponentIdentity = function checkComponentIdentity(child) {
        return component.id && child.id === component.id;
      };
      var componentIndex = this.layout.children.findIndex(checkComponentIdentity);
      if (componentIndex === -1) {
        componentIndex = this.layout.children.findIndex(function (child) {
          return child.children.length > 0 && child.children.findIndex(checkComponentIdentity) >= 0;
        });
      }
      return componentIndex;
    }
  }, {
    key: "moveLayoutComponent",
    value: function moveLayoutComponent(componentId, to) {
      var componentIndex = this.getLayoutComponentIndex(componentId);
      if (componentIndex >= 0) {
        this.reorderTreeChildren(this.layout, componentIndex, to);
        return true;
      }
      return false;
    }
  }, {
    key: "moveLayoutComponentUp",
    value: function moveLayoutComponentUp(componentId) {
      var componentIndex = this.getLayoutComponentIndex(componentId);
      if (componentIndex > 0) {
        return this.moveLayoutComponent(componentId, componentIndex - 1);
      }
      return false;
    }
  }, {
    key: "moveLayoutComponentDown",
    value: function moveLayoutComponentDown(componentId) {
      var componentIndex = this.getLayoutComponentIndex(componentId);
      if (componentIndex < this.layout.children.length - 1) {
        return this.moveLayoutComponent(componentId, componentIndex + 1);
      }
      return false;
    }
  }, {
    key: "updateComponentProperties",
    value: function updateComponentProperties(componentId, newProps) {
      var component = this.getComponentById(componentId);
      if (!component) {
        return false;
      }
      component.properties = _deepMerge(component.properties, newProps);
      return true;
    }
  }, {
    key: "setLayoutComponentHidden",
    value: function setLayoutComponentHidden(componentId, hidden) {
      var result = this.fromTreeGetComponentByIdAndParent(this.layout, componentId);
      if (!result) {
        return false;
      }
      var parent = result.parent,
        component = result.component;
      component.hidden = hidden;
      if (parent && parent.id !== this.layout.id) {
        return this.setLayoutComponentHidden(parent.id, hidden);
      }
      return true;
    }
  }, {
    key: "createLayoutComponentWithChildren",
    value: function createLayoutComponentWithChildren(layoutChildren) {
      if (this.document === null) {
        return false;
      }
      this.document.children.push({
        id: 'layout',
        component: 'Layout',
        properties: {},
        children: layoutChildren,
        hidden: false
      });
      return true;
    }
  }, {
    key: "replaceLayoutChildren",
    value: function replaceLayoutChildren(newChildren) {
      if (this.layout === null) {
        return this.createLayoutComponentWithChildren(newChildren);
      }
      this.layout.children = newChildren;
      return true;
    }
  }, {
    key: "removeLayoutComponent",
    value: function removeLayoutComponent(componentId) {
      var result = this.fromTreeGetComponentByIdAndParent(this.layout, componentId);
      if (!result) {
        return false;
      }
      var parent = result.parent;
      if (parent && parent.id !== this.layout.id) {
        return this.removeLayoutComponent(parent.id);
      }
      var filteredChildren = this.layout.children.filter(function (child) {
        return child.id !== componentId;
      });
      this.replaceLayoutChildren(filteredChildren);
      return true;
    }
  }, {
    key: "addLayoutComponent",
    value: function addLayoutComponent(component, position) {
      this.layout.children.splice(position, 0, component);
      return true;
    }
  }]);
}();
exports.Appearance = Appearance;
exports["default"] = Appearance;
